import TemplateView from "../TemplateView"
import $ from 'jquery'
import {defer, isOrderFullyExistsAtTheBeginningOf} from '../atUtils'

/*
* Constants for interactions jquery Sortable plugin. Do not use for styling
* */
const DRAG_ELEMENT_CLASS = 'draggableElement'
const CONNECT_WITH_PREFIX = 'connectWith_'
const DRAGGABLE_ITEM_CONTAINER_ID = '#draggableItemContainer'
const DRAGGABLE_ITEM_Z_INDEX = 9999

/*
* Constants for styling elements
* */
const ON_DRAG_CLASS = 'onDrag'

const defaultSortableConfig = {
    axis: false,
    cloneItem: false,
    tolerance: 'pointer',
    containmentEl: false,
    connectWithClass: false,
    restrictDragElement: false,
    placeholderClass: 'sortablePlaceholder'
}

export default class SortableListContainer extends TemplateView {
    constructor({
        itemRenderer,
        canDragItemPredicate = () => true,
        placeholderText = null,
        sortableConfig = {},
        onItemDragging = () => {},
        onItemDragStart = () => {},
        onItemDragStop = () => {},
        onDragOver = () => {},
        onDragOut = () => {},
        onPositionChangedCb = () => {},
        onItemReceiveCb = () => {},
        onItemRemoveCb = () => {}
    }) {
        super(null)

        this.state = {
            items: [],
            draggableItemPosition: null,
            preventPositionChangedCb: false,
            canDrop: false,
            previousCanDrop: false,
            itemDraggedOutOfContainer: false,
            additionalPlaceholderClass: "",
            needRefreshSortable: false,
        }

        this.params = {
            itemRenderer,
            canDragItemPredicate,
            placeholderText
        }

        this.sortableConfig = {...defaultSortableConfig, ...sortableConfig}

        this.callbacks = {
            onItemDragging,
            onItemDragStart,
            onItemDragStop,
            onDragOver,
            onDragOut,
            onPositionChangedCb,
            onItemReceiveCb,
            onItemRemoveCb
        }

        this.onStatePropertyChanged('items', (items, prevStateItems) => this._updateRows(items, prevStateItems))
        this.onStatePropertyChanged('additionalPlaceholderClass', (additionalClass) => {
            this.getEl().sortable('option', 'placeholder', this.sortableConfig.placeholderClass + ' ' + additionalClass)
        })

        this.onStatePropertyBecameTrue("needRefreshSortable", () => this._refreshSortable())
    }

    templateHtml() {
        return '<div class="draggableListContainer"\>'
    }

    afterRender() {

        if ($(DRAGGABLE_ITEM_CONTAINER_ID).length === 0) {
            $('body').append(`<div id="${DRAGGABLE_ITEM_CONTAINER_ID.substring(1)}"/>`)
        }

        if (this.sortableConfig.connectWithClass) {
            this.getEl().addClass(CONNECT_WITH_PREFIX + this.sortableConfig.connectWithClass)
        }

        this.getEl().sortable({
            appendTo: DRAGGABLE_ITEM_CONTAINER_ID,
            zIndex: DRAGGABLE_ITEM_Z_INDEX,
            helper: this.sortableConfig.cloneItem ? "clone" : "original",
            placeholder: this.sortableConfig.placeholderClass,
            cancel: ".disabled",
            axis: this.sortableConfig.axis,
            distance: 15,
            containment: this.sortableConfig.containmentEl || false,
            tolerance: this.sortableConfig.tolerance,
            handle: this.sortableConfig.restrictDragElement && `.${DRAG_ELEMENT_CLASS}`,
            connectWith: this.sortableConfig.connectWithClass && (`.${CONNECT_WITH_PREFIX}${this.sortableConfig.connectWithClass}`),
            scroll: false,
            cursor: "move",
            cursorAt: this.sortableConfig.cursorAt ? this.sortableConfig.cursorAt : false,
        })


        this.getEl().on('sortstart', (e, ui) => {
            $(DRAGGABLE_ITEM_CONTAINER_ID).show()

            ui.helper.addClass(ON_DRAG_CLASS)

            /* add tabindex to dragging element to focus on it and unfocus all available page inputs
            and add on blur event to disallow change focus on TAB key */
            ui.helper.attr('tabindex', 1).focus()
            ui.helper.blur(() => ui.helper.focus())

            if (this.sortableConfig.cloneItem) {
                ui.item.addClass('clone')
            }
            this.setStateInternal({
                previousCanDrop: this.state.canDrop,
                canDrop: true,
                itemDraggedOutOfContainer: false,
                preventPositionChangedCb: false,
                draggableItemPosition: ui.item.index()
            })
            this.callbacks.onItemDragStart({
                id: this.state.items[this.state.draggableItemPosition].id,
                currentPrecedingId: this.state.draggableItemPosition === 0 ? null : this.state.items[this.state.draggableItemPosition - 1].id
            })
        })

        this.getEl().on('sortstop', (e, ui) => {
            ui.item.removeClass(ON_DRAG_CLASS).removeAttr('tabindex')

            $(DRAGGABLE_ITEM_CONTAINER_ID).hide()

            this.callbacks.onItemDragStop()

            if (this.sortableConfig.cloneItem) {
                ui.item.removeClass('clone')
            }

            const itemIndex = ui.item.index()

            if (!this.state.preventPositionChangedCb && this.state.draggableItemPosition !== itemIndex) {
                const precedingId = itemIndex === 0 ? null
                                                    : this.state.draggableItemPosition > itemIndex
                                                      ? this.state.items[itemIndex - 1].id
                                                      : this.state.items[itemIndex].id
                this.callbacks.onPositionChangedCb({
                    id: this.state.items[this.state.draggableItemPosition].id,
                    itemIndex: ui.item.index(),
                    precedingId
                })
            }

            this.setStateInternal({
                draggableItemPosition: null,
                canDrop: this.state.previousCanDrop
            })
        })

        this.getEl().on('sortreceive', (e, ui) => {
            if (this.state.itemDraggedOutOfContainer || !this.state.canDrop) {
                ui.sender.sortable('cancel')
            } else {
                const itemIndex = ui.item.index()
                ui.item.remove()
                defer(() => this.callbacks.onItemReceiveCb({itemIndex}))
            }
        })

        this.getEl().on('sortremove', (e, ui) => {
            this.setStateInternal({preventPositionChangedCb: true})
            this.callbacks.onItemRemoveCb()
        })

        this.getEl().on('sortover', (e, ui) => {
            if (this.state.canDrop) {
                ui.helper.removeClass('undroppable')
                if (this.sortableConfig.cloneItem) {
                    this.state.draggableItemPosition !== null ? ui.item.hide() : ui.item.show()
                }
                if (this.params.placeholderText) {
                    ui.placeholder.text(this.params.placeholderText)
                }
                ui.placeholder.show()
                this.setStateInternal({itemDraggedOutOfContainer: false})
            }
            this.callbacks.onDragOver()
        })

        this.getEl().on('sortout', (e, ui) => {
            if (ui.helper) {
                ui.helper.addClass('undroppable');
            }
            ui.placeholder.hide()
            ui.item.show()
            this.setStateInternal({itemDraggedOutOfContainer: true})
            this.callbacks.onDragOut()
        })

        this.getEl().on('sort', (e, ui) => {
            this.$containerEl.trigger('sortableList_itemDrag', e)
        })
    }

    cancelDrag() {
        this.getEl().sortable("cancel")
    }

    _updateRows(items, prevStateItems) {
        if (!isOrderFullyExistsAtTheBeginningOf(prevStateItems, items) || prevStateItems.length === 0) {
            this.$el.empty()
            this._appendRows(items)
        } else {
            this._appendRows(items.slice(prevStateItems.length))
        }
    }

    _appendRows(items) {
        items.forEach(item => {
            const node = this.params.itemRenderer(item).init(this.getEl());

            if (!this.params.canDragItemPredicate(item)) {
                node.getEl().on('mousedown', (e) => e.stopPropagation())
            }

            if (this.sortableConfig.restrictDragElement) {
                if (node.getDraggableEl) {
                    node.getDraggableEl().toggleClass(DRAG_ELEMENT_CLASS, true)
                } else {
                    console.error('need to implement `getDraggableEl` into item element')
                }
            }
        })
    }

    _refreshSortable() {
        this.getEl().sortable('refresh')
        this.setStateInternal({needRefreshSortable: false})
    }
}


// WEBPACK FOOTER //
// ./web/js/components/SortableListContainer.js